// apps/pdf-suite/web/src/components/SignInRequired.jsx
// Shown on cloud-backed surfaces (AI, eSign, Account) when there is no live
// Firebase session — e.g. a licensed desktop user who signed out (Phase 2
// logout-capable activation): local PDF tools keep working; these don't.
import { useLocation } from 'react-router-dom';
import { useWorkspaceNavigate as useNavigate } from '@/contexts/DocumentWorkspace';
import { LogIn } from 'lucide-react';

export default function SignInRequired({ feature = 'this feature', compact = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const next = encodeURIComponent(location.pathname);
  return (
    <div className={compact
      ? 'flex flex-col items-center justify-center h-full px-6 py-10 text-center'
      : 'max-w-xl mx-auto px-4 py-16 text-center'}>
      <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center mb-4 mx-auto">
        <LogIn className="w-6 h-6 text-indigo-600" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900">Sign in to use {feature}</h2>
      <p className="text-sm text-gray-600 mt-1 mb-5 max-w-xs mx-auto">
        Your PDF tools keep working offline — {feature} needs your Scrivar account.
      </p>
      <button
        type="button"
        onClick={() => navigate(`/login?next=${next}`)}
        className="inline-flex items-center gap-1 rounded-lg bg-indigo-600 text-white px-5 py-2 text-sm font-semibold hover:bg-indigo-700"
      >
        Sign in
      </button>
    </div>
  );
}
